var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-trash 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66591 1.83362L5.99926 2.50027H2.66602V3.83356H3.33266V13.8333C3.33266 14.1814 3.46021 14.5363 3.71156 14.7877C3.96291 15.039 4.31782 15.1666 4.66596 15.1666H11.3324C11.6806 15.1666 12.0355 15.039 12.2868 14.7877C12.5382 14.5363 12.6657 14.1814 12.6657 13.8333V3.83356H13.3324V2.50027H9.99915L9.3325 1.83362H6.66591ZM4.66596 3.83356H11.3324V13.8333H4.66596V3.83356ZM5.99926 5.16686V12.5H7.33256V5.16686H5.99926ZM8.66585 5.16686V12.5H9.99915V5.16686H8.66585Z",
    fill: "#585858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.dbf59d40614b4c9213abe224496b9333.svg";
export { ForwardRef as ReactComponent };